// frontend/src/utils/csrf.js

/**
 * 브라우저 document.cookie 에서 주어진 name의 쿠키 값을 추출
 * (Django 기본 CSRF 쿠키 이름은 'csrftoken')
 */
export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return '';
  }